import React, { useEffect, useRef, useState } from 'react';

import { shape, string } from 'prop-types';

import { Loader } from 'Components';

const Embed = ({ title = 'SDP Visualize', src = '', ...props }) => {
  // ref for the iframe HTML element
  const iframeEl = useRef(null);
  // ref for the current `frameSrc` attribute
  const frameSrc = useRef(src);
  // eslint-disable-next-line no-unused-vars
  const [frame, setFrame] = useState();

  function useInnerHeight() {
    const [innerHeight, setInnerHeight] = useState(window.innerHeight);
    useEffect(() => {
      const onResize = () => setInnerHeight(window.innerHeight);
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }, []);
    return innerHeight - 170;
  }

  const innerHeight = useInnerHeight();

  useEffect(
    () =>
      ['local', 'qa'].includes(process.env.REACT_APP_ENV) ||
      console.log(title, frameSrc.current, { iframeEl, frame }),
    []
  );

  return iframeEl ? (
    <iframe
      {...props}
      ref={iframeEl}
      src={frameSrc.current}
      title={title}
      className={props?.className}
      style={
        Object.keys(props?.style).length
          ? props.style
          : {
              border: 'none',
              width: '100%',
              height: innerHeight,
              overflow: 'hidden'
            }
      }
      data-testid="embed-component"
    />
  ) : (
    <Loader />
  );
};

export default Embed;

Embed.propTypes = {
  title: string,
  src: string.isRequired,
  className: string,
  style: shape({})
};

Embed.defaultProps = {
  title: '',
  className: '',
  style: {}
};
